require("../../base/js/app.js");
require('bootstrap-datepicker');


// Coupon copy code, only works on https
const couponCopyBtns = document.querySelectorAll('.js-coupon__copy');

if (couponCopyBtns.length > 0) {
    couponCopyBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const codeText = btn.closest('.js-coupon').querySelector('.js-coupon__input');

            codeText.select();
            codeText.setSelectionRange(0, 99999);

            navigator.clipboard.writeText(codeText.value);
        });
    })
}


// WEBPACK FOOTER //
// ./resources/assets/default_benefit/js/app.js